"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyle = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactMapGl = require("react-map-gl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _circle = _interopRequireDefault(require("@turf/circle"));

var _baseMap = require("./base-map");

var _propTypes2 = require("./propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultStyle = {
  fillColor: '#004864',
  fillOpacity: 0.5,
  strokeColor: '#004864',
  strokeWeight: 1,
  strokeOpacity: 0.5
};
exports.defaultStyle = defaultStyle;

var GeoJson = function GeoJson(_ref) {
  var _mapInstances$google;

  var unmappedFeature = _ref.feature,
      featureStyle = _ref.featureStyle,
      layerId = _ref.layerId;

  var _useMapType = (0, _baseMap.useMapType)(),
      mapType = _useMapType.mapType,
      types = _useMapType.types;

  var mapInstances = (0, _baseMap.useMapInstance)();
  var google = (_mapInstances$google = mapInstances.google) !== null && _mapInstances$google !== void 0 ? _mapInstances$google : {};
  var layerStyle = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, defaultStyle), featureStyle);
  }, [featureStyle]);
  var polygonStyle = (0, _react.useMemo)(function () {
    var fillColor = layerStyle.fillColor,
        fillOpacity = layerStyle.fillOpacity;
    return {
      'fill-color': fillColor,
      'fill-opacity': fillOpacity
    };
  }, [layerStyle]);
  var lineStringStyle = (0, _react.useMemo)(function () {
    var strokeColor = layerStyle.strokeColor,
        strokeWeight = layerStyle.strokeWeight,
        strokeOpacity = layerStyle.strokeOpacity;
    return {
      'line-color': strokeColor,
      'line-width': strokeWeight,
      'line-opacity': strokeOpacity
    };
  }, [layerStyle]);
  var mappedFeature = (0, _react.useMemo)(function () {
    var featureToCircle = function featureToCircle(feat) {
      var _feat$geometry;

      if (((_feat$geometry = feat.geometry) === null || _feat$geometry === void 0 ? void 0 : _feat$geometry.type) === 'Point' && feat.properties.radius) {
        return (0, _circle["default"])(feat.geometry.coordinates, feat.properties.radius, {
          units: 'meters',
          properties: _objectSpread(_objectSpread({}, feat.properties), {}, {
            shape: 'Circle'
          })
        });
      }

      return feat;
    };

    if (!unmappedFeature) {
      return {
        type: 'Feature',
        geometry: null,
        properties: {}
      };
    }

    return featureToCircle(unmappedFeature);
  }, [unmappedFeature]); // google only

  var _useMapEvents = (0, _baseMap.useMapEvents)(layerId),
      onClick = _useMapEvents.onClick,
      onMouseDown = _useMapEvents.onMouseDown,
      onMouseUp = _useMapEvents.onMouseUp,
      onHover = _useMapEvents.onHover;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      dataLayer = _useState2[0],
      setDataLayer = _useState2[1];

  var prevFeatures = (0, _hooks.usePrevious)(mappedFeature);
  (0, _react.useEffect)(function () {
    var handleClick;
    var handleMouseDown;
    var handleMouseUp;
    var handleMouseMove;

    if (mapType === types.google) {
      if (!dataLayer && google.maps) {
        var newDataLayer = new google.maps.Data();
        newDataLayer.setStyle(layerStyle);
        newDataLayer.addGeoJson(mappedFeature);
        newDataLayer.setMap(google.map);
        handleClick = newDataLayer.addListener('click', function (_ref2) {
          var latLng = _ref2.latLng;
          return onClick({
            latitude: latLng.lat(),
            longitude: latLng.lng()
          });
        });
        handleMouseDown = newDataLayer.addListener('mousedown', function (_ref3) {
          var latLng = _ref3.latLng;
          return onMouseDown({
            latitude: latLng.lat(),
            longitude: latLng.lng()
          });
        });
        handleMouseUp = newDataLayer.addListener('mouseup', function (_ref4) {
          var latLng = _ref4.latLng;
          return onMouseUp({
            latitude: latLng.lat(),
            longitude: latLng.lng()
          });
        });
        handleMouseMove = newDataLayer.addListener('mousemove', function (_ref5) {
          var latLng = _ref5.latLng;
          return onHover({
            latitude: latLng.lat(),
            longitude: latLng.lng()
          });
        });
        setDataLayer(newDataLayer);
      } // lineString


      if (dataLayer) {
        if (mappedFeature !== prevFeatures) {
          dataLayer.setStyle(layerStyle);
          dataLayer.forEach(function (feature) {
            return dataLayer.remove(feature);
          });
          dataLayer.addGeoJson(mappedFeature);
        }

        dataLayer.setMap(google.map);
      }
    }

    return function () {
      if (dataLayer) {
        dataLayer.setMap(null);
        google.maps.event.removeListener(handleClick);
        google.maps.event.removeListener(handleMouseDown);
        google.maps.event.removeListener(handleMouseUp);
        google.maps.event.removeListener(handleMouseMove);
      }
    };
  }, [dataLayer, google.map, google.maps, mapType, mappedFeature, onClick, onHover, onMouseDown, onMouseUp, prevFeatures, layerStyle, types.google]); // render nothing, because google api is directly used

  if (mapType === types.google) {
    return null;
  }

  if (mappedFeature.geometry && mappedFeature.geometry.type === 'LineString') {
    return /*#__PURE__*/_react["default"].createElement(_reactMapGl.Source, {
      type: "geojson",
      data: mappedFeature
    }, /*#__PURE__*/_react["default"].createElement(_reactMapGl.Layer, {
      id: layerId,
      paint: lineStringStyle,
      type: "line"
    }));
  }

  if (mappedFeature.geometry && mappedFeature.geometry.type === 'Polygon') {
    return /*#__PURE__*/_react["default"].createElement(_reactMapGl.Source, {
      type: "geojson",
      data: mappedFeature
    }, /*#__PURE__*/_react["default"].createElement(_reactMapGl.Layer, {
      id: layerId,
      paint: polygonStyle,
      type: "fill"
    }));
  }

  return null;
};

GeoJson.propTypes = {
  feature: (0, _propTypes2.FeatureShape)(),
  featureStyle: _propTypes["default"].shape({
    fillColor: _propTypes["default"].string,
    fillOpacity: _propTypes["default"].number,
    strokeColor: _propTypes["default"].string,
    strokeWeight: _propTypes["default"].number,
    strokeOpacity: _propTypes["default"].number
  }),
  layerId: _propTypes["default"].string
};
GeoJson.defaultProps = {
  feature: null,
  featureStyle: defaultStyle,
  layerId: undefined
};
var _default = GeoJson;
exports["default"] = _default;